<script lang="ts">
    import { Alert } from "sveltestrap";
    import { appManager } from "../../AppManagerStore";
    import { _ } from "svelte-i18n";

    let currentPass: string = "";
    let newPass: string = "";
    let confirmPass: string = "";
    let passConfirmed: boolean = false;
    let state: "unchanged" | "changed" | "failed" = "unchanged";

    $: if (typeof newPass !== "undefined" && newPass.length > 0) {
        passConfirmed = newPass === confirmPass;
    }

    const onSave = async () => {
        const accessToken = await $appManager.Authenticator.getAccessToken();

        const success = await $appManager.IdentityApi.changePassword({
            accessToken: accessToken,
            data: {
                oldPassword: currentPass,
                newPassword: newPass,
                confirmPassword: confirmPass,
            },
        });

        if (success) {
            state = "changed";

            setTimeout(() => {
                state = "unchanged";
            }, 2000);
        } else {
            state = "failed";
        }
    };
</script>

<div class="card card-bleed shadow-light-lg mb-6">
    <div class="card-header">
        <h4 class="mb-0">{$_("users.settings.general.changepass.title")}</h4>
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label class="form-label" for="currentpass"
                        >{$_("users.settings.general.changepass.old")}</label>
                    <input
                        class="form-control"
                        id="currentpass"
                        type="password"
                        placeholder={$_(
                            "users.settings.general.changepass.old"
                        )}
                        bind:value={currentPass} />
                </div>
            </div>
            <div class="col-12">
                <div class="form-group">
                    <label class="form-label" for="newpass"
                        >{$_("users.settings.general.changepass.new")}</label>
                    <input
                        class="form-control"
                        id="newpass"
                        type="password"
                        placeholder={$_(
                            "users.settings.general.changepass.new"
                        )}
                        bind:value={newPass} />
                </div>
            </div>
            <div class="col-12">
                <div class="form-group">
                    <label class="form-label" for="confirmpass"
                        >{$_(
                            "users.settings.general.changepass.confirm"
                        )}</label>
                    <input
                        class="form-control"
                        id="confirmpass"
                        type="password"
                        placeholder={$_(
                            "users.settings.general.changepass.confirm"
                        )}
                        bind:value={confirmPass} />
                </div>
            </div>
            <div class="col-12 col-md-auto">
                <button
                    class="btn w-100 btn-primary {passConfirmed
                        ? ''
                        : 'disabled'}"
                    on:click={async () => await onSave()}>
                    {$_("users.settings.general.changepass.ok")}
                </button>
            </div>

            {#if state === "changed"}
                <Alert class="mt-2"
                    >{$_(
                        "users.settings.general.changepass.changed.part1"
                    )}</Alert>
            {/if}

            {#if state === "failed"}
                <Alert class="mt-2"
                    >{$_(
                        "users.settings.general.changepass.failed.part1"
                    )}</Alert>
            {/if}
        </div>
    </div>
</div>
